var _animate, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 200
    },
    id: "dc-spinner",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "-68 -17 180 180",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    x: 14,
    y: 21,
    fontSize: "2px",
    style: {
      letterSpacing: 0.6
    },
    fill: "black"
  }, "LOADING\n                    ", _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#373a42",
    d: "M20,35c-8.271,0-15-6.729-15-15S11.729,5,20,5s15,6.729,15,15S28.271,35,20,35z M20,5.203     C11.841,5.203,5.203,11.841,5.203,20c0,8.159,6.638,14.797,14.797,14.797S34.797,28.159,34.797,20     C34.797,11.841,28.159,5.203,20,5.203z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#373a42",
    d: "M20,33.125c-7.237,0-13.125-5.888-13.125-13.125S12.763,6.875,20,6.875S33.125,12.763,33.125,20     S27.237,33.125,20,33.125z M20,7.078C12.875,7.078,7.078,12.875,7.078,20c0,7.125,5.797,12.922,12.922,12.922     S32.922,27.125,32.922,20C32.922,12.875,27.125,7.078,20,7.078z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0062ff",
    stroke: "#0062ff",
    strokeWidth: 0.6027,
    strokeMiterlimit: 10,
    d: "M5.203,20 c0-8.159,6.638-14.797,14.797-14.797V5C11.729,5,5,11.729,5,20s6.729,15,15,15v-0.203C11.841,34.797,5.203,28.159,5.203,20z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 20 20",
    to: "360 20 20",
    calcMode: "spline",
    keySplines: "0.4, 0, 0.2, 1",
    keyTimes: "0;1",
    dur: "4.5s",
    repeatCount: "indefinite"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC542",
    stroke: "#FFC542",
    strokeWidth: 0.2027,
    strokeMiterlimit: 10,
    d: "M7.078,20   c0-7.125,5.797-12.922,12.922-12.922V6.875C12.763,6.875,6.875,12.763,6.875,20S12.763,33.125,20,33.125v-0.203   C12.875,32.922,7.078,27.125,7.078,20z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 20 20",
    to: "360 20 20",
    dur: "5s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin);
export default __webpack_public_path__ + "static/media/spin.70d7bacb2b8856ce10f4f73bbfc04700.svg";
export { ForwardRef as ReactComponent };